<div class="container-fluid pt-2 h-100">
  <div class="pre-processing-container h-100 d-flex flex-column">
    <div class="header d-flex justify-content-center flex-column">
      <span class="header-5">{{ category }}</span>
    </div>
    <div class="card-body">
      @if(this.category === "Metadata Catalogue"){
        <div class="d-flex justify-content-between  align-items-center my-2">
          <span class="w-100 accello-general-text12">Select the items you want to remove from the list using the checkboxes.</span>
          <div class="w-100 d-flex justify-content-end">
          <button
            class="btn-accello-secondary btn-accello mx-2"
            (click)="addNewField()"
          >
            <img
              src="assets/images/virtusa-icons/add-icon-dark.svg"
              alt="Add Icon"
            />
            Add New Field
          </button>
          <button
            class="btn-accello-ternary btn-accello"
            (click)="removeSelectedFields()" [disabled]="isFileRemoveDisabled"
          >
            <img
              src="assets/images/virtusa-icons/remove-icon-dark.svg"
              alt="Remove Icon" 
            />
            Remove Fields
          </button>
          </div>
        </div>
      } @else{
        <div class="d-flex justify-content-between  align-items-center my-2">
          <span class="w-100  accello-general-text12">Only one test case document is allowed to proceed to the next step.</span>
          <div class="w-100 d-flex justify-content-end">
            <button
            class="btn-accello-secondary btn-accello mx-2"
            (click)="addFile()"
          >
            <img
              src="assets/images/virtusa-icons/add-icon-dark.svg"
              alt="Add Icon"
            />
            Add New File
          </button>
          <button
            class="btn-accello-ternary btn-accello"
            (click)="openDeleteConfirmation()"[disabled]="isFileRemoveDisabled"
          >
            <img
              src="assets/images/virtusa-icons/remove-icon-dark.svg"
              alt="Remove Icon"
            />
            Remove File
          </button>
          </div>
        </div>
      }
      <div *ngIf="recentRecords && !isLoading" class="col-md-12">
        <app-zorro-table
          tableId="pre-prc"
          [columns]="recentRecords?.columns"
          [data]="recentRecords?.rows"
          (onRowSelect)="handleRowSelection($event)"
          (handleActions)="handleActions($event)"
          class="w-100"
        ></app-zorro-table>
      </div>
      <div
        *ngIf="isLoading"
        class="loader-content d-flex flex-column justify-content-center"
      >
        <app-loading [text]="'Loading...'"></app-loading>
      </div>
    </div>
    <div class="footer d-flex justify-content-end">
      <button class="btn btn-accello-primary d-block mx-2 btn-spin" [disabled]="isDisabled" (click)="processData()">
        <span>Next</span>
          @if(isProcessing){
          <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
          }</button>
    </div>
  </div>
</div>
